var map = {
  "./etimesdesktop/DiscussionForum.scss": [
    "62876",
    7,
    "87458"
  ],
  "./etimesdesktop/index.js": [
    "27071",
    9,
    "51035",
    "47387",
    "3199",
    "98600",
    "67508",
    "13529",
    "17348",
    "17961",
    "99717"
  ],
  "./etimesmobile": [
    "47987",
    9,
    "9598",
    "6850",
    "47387",
    "3199",
    "88565",
    "68454",
    "98600",
    "67508",
    "60146",
    "17348",
    "17961",
    "41007"
  ],
  "./etimesmobile/index": [
    "47987",
    9,
    "9598",
    "6850",
    "47387",
    "3199",
    "88565",
    "68454",
    "98600",
    "67508",
    "60146",
    "17348",
    "17961",
    "41007"
  ],
  "./etimesdesktop/DiscussionForum": [
    "92494",
    9,
    "67508",
    "16833"
  ],
  "./etimesmobile/": [
    "47987",
    9,
    "9598",
    "6850",
    "47387",
    "3199",
    "88565",
    "68454",
    "98600",
    "67508",
    "60146",
    "17348",
    "17961",
    "41007"
  ],
  "./etimesdesktop/": [
    "27071",
    9,
    "51035",
    "47387",
    "3199",
    "98600",
    "67508",
    "13529",
    "17348",
    "17961",
    "99717"
  ],
  "./etimesmobile/DiscussionForum": [
    "52170",
    9,
    "67508",
    "86439"
  ],
  "./etimesmobile/DiscussionForum.js": [
    "52170",
    9,
    "67508",
    "86439"
  ],
  "./etimesdesktop/index": [
    "27071",
    9,
    "51035",
    "47387",
    "3199",
    "98600",
    "67508",
    "13529",
    "17348",
    "17961",
    "99717"
  ],
  "./etimesdesktop": [
    "27071",
    9,
    "51035",
    "47387",
    "3199",
    "98600",
    "67508",
    "13529",
    "17348",
    "17961",
    "99717"
  ],
  "./etimesmobile/DiscussionForum.scss": [
    "96082",
    7,
    "66716"
  ],
  "./etimesmobile/index.js": [
    "47987",
    9,
    "9598",
    "6850",
    "47387",
    "3199",
    "88565",
    "68454",
    "98600",
    "67508",
    "60146",
    "17348",
    "17961",
    "41007"
  ],
  "./etimesdesktop/DiscussionForum.js": [
    "92494",
    9,
    "67508",
    "16833"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 80438;
module.exports = __rspack_async_context;
